import { ReactComponent as LockIcon } from 'icons/ico-lock.svg';
import { useSelector } from 'react-redux';
import { useTranslations } from 'utils';
import { isDocVerifyActive } from '../../selectors';

type Props = {
  status:
    | 'available'
    | 'deleted'
    | 'invalid'
    | 'pending'
    | 'virus_infected'
    | 'void'
    | 'doc_verify_in_progress'
    | 'doc_verify_with_errors';
};
const FileAnalysisStatus = ({ status }: Props) => {
  const i18n = useTranslations();
  let statusText = i18n.t('scanningFotViruses.text');
  const useDocVerify = useSelector(isDocVerifyActive);
  if (useDocVerify) {
    if (status === 'pending') {
      statusText = `${i18n.t('documentCollector.scanningFotViruses', {
        current: '1',
        total: '2',
      })}`;
    } else if (status === 'doc_verify_in_progress') {
      statusText = `${i18n.t('documentCollector.docVerifyInProgress', {
        current: '2',
        total: '2',
      })}`;
    }
  }
  return (
    <div data-testid="scanning-for-viruses">
      {!useDocVerify && <LockIcon />}
      <span className="FileAnalysisStatus-Text text-right text-[14px] font-[400] italic leading-[15px] tracking-normal text-[#657A8D]">
        {statusText}
      </span>
    </div>
  );
};

export { FileAnalysisStatus };
